// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"c8ef9f3e","465":"372c51d6","748":"70d7fc0f","852":"8746862a"}[chunkId] + ".chunk.js";
};